
import React, { Component } from 'react';
import moment from 'moment';
import styled from 'styled-components';
import { Button, IconButton } from '@material-ui/core';
import ArrowBackIosOutlinedIcon from '@material-ui/icons/ArrowBackIosOutlined';
import ArrowForwardIosOutlinedIcon from '@material-ui/icons/ArrowForwardIosOutlined';
import { DateWidget } from './DateWidget';


const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
`;

const DateNav = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
`;


export class DateDayWidget extends Component {

  getMomentValue = () => {
    const { value } = this.props;
    if (value && moment(value).isValid()) {
      return moment(value);
    }
    return null;
  };

  emitChange = (next) => {
    const { onChange } = this.props;
    if (!onChange) {
      return;
    }
    if (next && moment(next).isValid()) {
      const date = moment(next);
      onChange(date.toDate(), date.format('YYYY-MM-DD'));
      return;
    }
    onChange(null, null);
  };

  handlePrevious = () => {
    const current = this.getMomentValue() || moment();
    this.emitChange(current.clone().subtract(1, 'd'));
  };

  handleNext = () => {
    const current = this.getMomentValue() || moment();
    this.emitChange(current.clone().add(1, 'd'));
  };

  handleToday = () => {
    this.emitChange(moment());
  };

  isToday = () => {
    const current = this.getMomentValue();
    return Boolean(current && current.isSame(moment(), 'day'));
  };

  render() {
    const { value, onChange, size = 'small', className, disabled, ...otherProps } = this.props;

    return (
      <Wrapper className={className}>
        <DateNav>
          <IconButton size="small" disabled={disabled} onClick={this.handlePrevious}>
            <ArrowBackIosOutlinedIcon fontSize="small" />
          </IconButton>
          <DateWidget
            value={value}
            onChange={onChange}
            size={size}
            disabled={disabled}
            className={'w-150'}
            {...otherProps}
          />
          <IconButton size="small" disabled={disabled} onClick={this.handleNext}>
            <ArrowForwardIosOutlinedIcon fontSize="small" />
          </IconButton>
        </DateNav>
        <Button
          onClick={this.handleToday}
          style={{fontWeight: 'normal'}}
          variant={'outlined'}
          disabled={disabled || this.isToday()}
        >
          Сегодня
        </Button>
      </Wrapper>
    );
  }
}
